import ModalHeader from '@molecules/ModalHeader';
import ModalWindow from '@organisms/modals/ModalWindow';
import {FC, useEffect, useState} from 'react';
import {
  TestCoverageModuleWrapper,
  ButtonsWrapper,
  ModalContent,
  ModalWrapper,
  ModuleEnableEditRow,
  TestCoverageModuleInfoWrapper,
  TestCoverageModuleInfo,
  TestCoverageModuleInfoRow,
} from './EditTestCoverageModal.styles';
import Button from '@atoms/Button';
import {Edit} from '@carbon/icons-react';
import {theme} from '@styles/theme';
import Text from '@atoms/Text';
import {ICell, IModule} from '@types';
import Switcher from '@atoms/Switcher';
import CoverageChart from '@atoms/CoverageChart';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '@store';
import {addCell} from '@store/slices/systems';
import NumberInput from '@atoms/NumberInput';

interface Props {
  isOpened: boolean;
  onCloseRequest: () => void;
  module?: IModule;
  test?: ICell;
  forPlan?: boolean;
  addCellForPlan?: (cellData: {
    coverage: number;
    auto_coverage: number;
    module_id: number;
    test_type_id: number;
  }) => void;
}

const EditTestCoverageModal: FC<Props> = ({
  isOpened,
  onCloseRequest,
  module,
  test,
  forPlan = false,
  addCellForPlan,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [editEnabled, setEditEnabled] = useState(false);
  const [coverage, setCoverage] = useState<number>(0);
  const [autoCoverage, setAutoCoverage] = useState<number>(0);

  useEffect(() => {
    if (test?.test_type_id) {
      setCoverage(test.coverage || 0);
      setAutoCoverage(test.auto_coverage || 0);
    }
  }, [test]);

  const onSave = () => {
    if (module?.id && test?.test_type_id) {
      if (forPlan && addCellForPlan) {
        addCellForPlan({
          coverage: coverage,
          auto_coverage: autoCoverage,
          module_id: module?.id,
          test_type_id: test?.test_type_id,
        });
      } else {
        dispatch(
          addCell({
            is_changeable: editEnabled,
            coverage: coverage,
            auto_coverage: autoCoverage,
            module_id: module?.id,
            test_type_id: test?.test_type_id,
          }),
        );
      }
    }
    onCloseRequest();
  };

  return (
    <ModalWindow isOpen={isOpened} overflowIsVisible>
      <ModalWrapper>
        <ModalHeader
          title={'Редактирование покрытия'}
          onClose={onCloseRequest}
          iconElement={<Edit size={21} fill={theme.colors.basic03} />}
        />
        <ModalContent>
          <TestCoverageModuleWrapper>
            {!forPlan && (
              <ModuleEnableEditRow>
                <Switcher
                  onClick={() => {
                    setEditEnabled(!editEnabled);
                  }}
                  checked={editEnabled}
                />
                <Text text="Доступен для редактирования" type="bodyM" />
              </ModuleEnableEditRow>
            )}
            <TestCoverageModuleInfoWrapper>
              <CoverageChart test={test} />
              <TestCoverageModuleInfo>
                <TestCoverageModuleInfoRow>
                  <Text
                    text="Название модуля"
                    type="tinyR"
                    color={theme.colors.basic01}
                  />
                  <Text text={module?.name || ''} type="bodyM" />
                </TestCoverageModuleInfoRow>
                <TestCoverageModuleInfoRow>
                  <Text text="Тип теста" type="tinyR" color={theme.colors.basic01} />
                  <Text text={test?.test_type_name || ''} type="bodyM" />
                </TestCoverageModuleInfoRow>
              </TestCoverageModuleInfo>
            </TestCoverageModuleInfoWrapper>
          </TestCoverageModuleWrapper>
          <NumberInput
            id="full-coverage"
            label="Общее покрытие тестом"
            value={coverage}
            onChange={e => setCoverage(Number(e.currentTarget.value))}
          />
          <NumberInput
            id="auto-coverage"
            label="Автоматизировано"
            value={coverage}
            onChange={e => setAutoCoverage(Number(e.currentTarget.value))}
          />
        </ModalContent>
        <ButtonsWrapper>
          <Button onClick={onSave} fullWidth title="Сохранить" variant="filled" />
          <Button
            fullWidth
            title="Отменить"
            onClick={() => {
              onCloseRequest();
            }}
          />
        </ButtonsWrapper>
      </ModalWrapper>
    </ModalWindow>
  );
};

export default EditTestCoverageModal;
